import Vue from 'vue'
import Router from 'vue-router'
import home from './routes/home'
import collect from './routes/collect'
import easyBid from './routes/easyBid'
import my from './routes/my'
import mall from './routes/mall'
import cart from './routes/cart'
import order from './routes/order'
Vue.use(Router)

export default () => {
  const router = new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      return savedPosition || {x: 0, y: 0}
    },
    routes: [
      home,
      my,
      mall,
      cart,
      order,
      collect,
      easyBid,
      {
        path: '*',
        redirect: '/'
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          auth: true
        },
        component: () => import('@/views/login')
      },
      {
        path: '/auth',
        name: 'auth',
        meta: {
          auth: true
        },
        component: () => import('@/views/auth')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register')
      },
      {
        path: '/address',
        name: 'address',
        component: () => import('@/views/my/area')
      }
    ]
  })
  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js